// @ts-nocheck
import { all, select, takeEvery } from 'redux-saga/effects';

import { REPORTING_ADVANCED_FILTER_APPLY_SETTINGS } from '../actions/reportingAdvancedFilter.actions';
import { getAdvancedFilters } from '../selectors/reportingAdvancedFilter.selectors';

function* triggerAdvancedFiltersApplied(action) {
  const { section } = action.data;
  if (section !== 'general') {
    return;
  }
  const advancedFilters = yield select(store => getAdvancedFilters(store, section));
  taptap.redux.model.trigger('advancedFiltersChanged', {
    advancedFilters,
    section
  });
}

export function* sagas() {
  yield all([takeEvery([REPORTING_ADVANCED_FILTER_APPLY_SETTINGS], triggerAdvancedFiltersApplied)]);
}
